import styled from 'styled-components';

export const MainContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const CenterContentContainer = styled.div`
    background-color: #f9f9f9;
    flex: 1;
`;

export const WidgetContentContainer = styled.div`
    max-width: 1366px;
    margin: 0 auto;
    background-color: #f9f9f9;
`;

export const WidgetContentContainerBg = styled.div`
    background-color: #f9f9f9;
    margin: 32px 16px 32px 16px;
    @media screen and (max-width: 768px) {
        margin: 16px;
    }
`;

export const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const List = styled.ul`
    margin: 0;
    padding: 0;
`;

export const ListItem = styled.li`
    list-style-type: none;
`;

export const StyledWidgets = styled(FlexCenter)`
    background-color: ${({ theme }) => theme.colors.whiteSmoke};
    padding: 1.5rem 1rem;
    font-family: ${({ theme }) => theme.font.defaults.fontFamily};
    flex-direction: column;

    @media screen and (max-width: 500px) {
        padding: 0;
        margin: 20px 10px;
    }

    @media screen and (min-width: 1366px) {
        max-width: 85.37rem;
        margin: auto;
    }
`;

export const FooterWapper = styled.div`
    margin-top: auto;
`;
export const WidgetsWrapper = styled.div`
    display: flex;
    gap: 1rem;
    max-width: 90rem;
    width: 100%;
    @media screen and (max-width: 600px) {
        flex-wrap: wrap;
    }
`;

export const LeftWrapper = styled.div`
    display: flex;
    row-gap: 30px;
    flex: 1;
    flex-direction: column;
    height: fit-content;

    @media screen and (max-width: 800px) {
        row-gap: 20px;
    }
`;
export const CloseIcon = styled.img`
    cursor: pointer;
    align-self: flex-start;
    height: 19px;
    width: 19px;
    color: #0a4a8d;
    margin-left: 20px;
`;
export const RightWrapper = styled.div`
    display: flex;
    row-gap: 30px;
    flex: 1;
    flex-direction: column;
    height: fit-content;
    @media screen and (max-width: 800px) {
        row-gap: 20px;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex: 1;
    gap: 37px;
    justify-content: space-between;
    width: 100%;

    @media screen and (max-width: 800px) {
        gap: 16px;
    }
`;

export const Wrapper1 = styled.div`
    display: flex;
`;

export const DxocWrapper = styled.div`
    display: flex;
`;

export const FirstSection = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    justify-content: space-between;
    max-width: 90rem;
    width: 100%;
    margin-bottom: 55px;
`;

export const H1 = styled.div`
    color: ${({ theme: { colors } }) => colors.pureBlack};
    font-size: 25px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 29px;
`;

export const H2 = styled.div`
    color: ${({ theme: { colors } }) => colors.pureBlack};
    font-size: 21px;
    letter-spacing: 0;
    line-height: 30px;
`;

export const H3 = styled.div`
    color: ${({ theme: { colors } }) => colors.pureBlack};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
`;

export const FlexColoumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const Amount = styled.div`
    color: ${({ theme: { colors } }) => colors.cyanDarkBlue};
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 26px;
`;

export const NotificationAlertWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 37px;

    @media screen and (max-width: 800px) {
        gap: 16px;
    }

    @media screen and (max-width: 700px) {
        flex-direction: column;
        gap: unset;
    }
`;

export const MobileViewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
export const EscrowWrapper = styled.div`
    [role='link'] {
        &:hover {
            color: #0a58ca;
        }
        cursor: pointer;
    }
`;
export const FormWrapper = styled.div`
    margin: 4rem auto;
    @media screen and (max-width: 480px) {
        width: 95%;
    }
    @media screen and (min-width: 481px) and (max-width: 768px) {
        width: 85%;
    }
    @media screen and (min-width: 769px) and (max-width: 992px) {
        width: 65%;
    }
    @media screen and (min-width: 993px) {
        width: 51%;
    }
`;

export const NewLoanInProgressConfettiWrapper = styled.div`
    width: '100%';
    margin: 'auto';
`;

export const PreviewLink = styled.a`
    &:hover {
        display: none !important;
    }
`;
export const ToastMessage = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

export const NaturalFormWrapper = styled.div`
    margin: 2rem auto;
`;
export const ReturnToHomeButtonWrapper = styled.div`
    position: absolute;
    right: 2%;
    margin-top: 50px;
    z-index: 1;
    @media (max-width: 800px) {
        margin-top: 10px;
    }
`;
export const SecureMessageContainer = styled.div`
    background-color: #F8F9FE);
    margin: 32px;
    flex-grow:1;
    box-shadow: '4px 4px 30px 0px rgba(29, 49, 70, 0.10)';
    @media screen and (max-width: 768px) {
        margin: 0 !important;
    }
    @media screen and (min-width: 1290px) {
        margin: auto;
        height: calc(100vh - 228px);
    }

    @media screen and (min-width: 769px) {
        justify-content: center;
        display: flex;
        padding: 32px 16px 32px 16px;
        margin: 0 !important;

    }
`;
